import React from "react";
import { Link } from "react-router-dom";
import { Sun, Check, ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";
import { useSite } from "../context/SiteContext";

export const SummerProgram = ({ standalone = false }) => {
    const { content } = useSite();
    const s = content.summer || {};
    const title = (s.title || "").split("\n");

    return (
        <section
            id="summer"
            data-testid="summer-section"
            className={`relative bg-[#14545E] text-white overflow-hidden ${
                standalone ? "pt-36 pb-28" : "py-24 lg:py-32"
            }`}
        >
            <div className="absolute -top-20 -right-20 w-96 h-96 bg-white/10 rounded-full blur-3xl" />
            <div className="absolute -bottom-32 -left-20 w-[500px] h-[500px] bg-[#0A1F3D]/30 rounded-full blur-3xl" />

            <div className="max-w-7xl mx-auto px-5 lg:px-10 relative grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
                <Reveal className="lg:col-span-6 order-2 lg:order-1">
                    <div className="relative">
                        <div className="absolute -inset-3 bg-white/10 rounded-3xl -z-10" />
                        <img
                            src={s.image}
                            alt={s.title}
                            className="w-full h-[400px] lg:h-[540px] object-cover rounded-2xl"
                        />
                        <div className="absolute -bottom-6 -left-6 hidden lg:flex items-center gap-3 bg-white text-[#0A1F3D] py-4 px-5 rounded-2xl shadow-xl">
                            <Sun className="text-[#14545E]" size={22} />
                            <div>
                                <div className="text-[10px] tracking-[0.2em] uppercase text-neutral-500">
                                    İyun — Avqust
                                </div>
                                <div className="font-serif-display text-lg">
                                    2026 yay sezonu
                                </div>
                            </div>
                        </div>
                    </div>
                </Reveal>

                <div className="lg:col-span-6 order-1 lg:order-2 space-y-7">
                    <Reveal>
                        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 text-white/90 text-[11px] tracking-[0.2em] uppercase">
                            {s.eyebrow}
                        </div>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
                            {title.map((line, i) => (
                                <div key={i}>{line}</div>
                            ))}
                        </h2>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <p className="text-white/80 text-base lg:text-lg leading-relaxed max-w-xl">
                            {s.body}
                        </p>
                    </Reveal>
                    <Reveal delay={0.3}>
                        <ul className="space-y-3 pt-2">
                            {(s.highlights || []).map((h, i) => (
                                <li
                                    key={i}
                                    data-testid={`summer-highlight-${i}`}
                                    className="flex items-start gap-3 text-white/90"
                                >
                                    <span className="mt-1 shrink-0 h-5 w-5 rounded-full bg-white/15 flex items-center justify-center">
                                        <Check size={12} />
                                    </span>
                                    <span className="text-sm">{h}</span>
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                    <Reveal delay={0.4}>
                        <Link
                            to="/elaqe"
                            data-testid="summer-cta"
                            className="group inline-flex items-center gap-2 bg-white text-[#0A1F3D] hover:bg-white/90 px-6 py-3.5 rounded-full text-sm transition-colors"
                        >
                            Yay proqramına yazıl
                            <ArrowRight
                                size={16}
                                className="transition-transform group-hover:translate-x-1"
                            />
                        </Link>
                    </Reveal>
                </div>
            </div>
        </section>
    );
};

export default SummerProgram;
